import { render, staticRenderFns } from "./BemerkungErgaenzenButton.vue?vue&type=template&id=db9b7d34"
import script from "./BemerkungErgaenzenButton.vue?vue&type=script&lang=js"
export * from "./BemerkungErgaenzenButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports